import {Injectable} from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import {HttpClient, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class UploadService {

  FOLDER = 'jsa-s3/';
  constructor(private http: HttpClient) { }


  uploadfile(file, callback) {

    const bucket = new S3(
      {
        accessKeyId: 'YOUR-ACCESS-KEY-ID',
        secretAccessKey: 'YOUR-SECRET-ACCESS-KEY',
        region: 'us-east-1'
      }
    );

    const params = {
      Bucket: 'jsa-angular4-bucket',
      Key: this.FOLDER + file.name,
      Body: file
    };

    bucket.upload(params, callback);
  }

  issuePreSignedURL(file: File) {
    const options = { params: new HttpParams().set('file-name', file.name).set('file-type', file.type) };
    return this.http.get(environment.server + 'issuePresignedURL', options);
  }

  uploadFileToS3(fileuploadurl, file): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': file.type}
      );
    const req = new HttpRequest('PUT', fileuploadurl, file,
      {
        headers: headers,
        // reportProgress: true,
      });
    return this.http.request(req);
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/upload.service.ts